import { render, staticRenderFns } from "./AdmissionFormModal.vue?vue&type=template&id=1de7f114&scoped=true&"
import script from "./AdmissionFormModal.vue?vue&type=script&lang=js&"
export * from "./AdmissionFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de7f114",
  null
  
)

export default component.exports